const Mutations = Object.freeze({
	SET_COMPUTED_FIELDS:
		'activityBuilder/activityComputedFields/SET_COMPUTED_FIELDS',
	SET_SELECTED_COPMUTED_FIELD:
		'activityBuilder/activityComputedFields/SET_SELECTED_COPMUTED_FIELD',
	SET_GRID_VIEW_FIELDS:
		'activityBuilder/activityComputedFields/SET_GRID_VIEW_FIELDS',
	SET_LOADING: 'activityBuilder/activityComputedFields/SET_LOADING',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/activityComputedFields/CLEAR',
	LOAD: 'activityBuilder/activityComputedFields/LOAD',
	LOAD_GRID_VIEW_FIELDS:
		'activityBuilder/activityComputedFields/LOAD_GRID_VIEW_FIELDS',
	LOAD_COMPUTED_FIELD_BY_ID:
		'activityBuilder/activityComputedFields/LOAD_COMPUTED_FIELD_BY_ID',
	INSERT_COMPUTED_FIELD:
		'activityBuilder/activityComputedFields/INSERT_COMPUTED_FIELD',
	UPDATE_COMPUTED_FIELD:
		'activityBuilder/activityComputedFields/UPDATE_COMPUTED_FIELD',
	DELETE_COMPUTED_FIELD:
		'activityBuilder/activityComputedFields/DELETE_COMPUTED_FIELD',
});

export const Getters = Object.freeze({
	SELECTED_COPMUTED_FIELD:
		'activityBuilder/activityComputedFields/SELECTED_COPMUTED_FIELD',
	GRID_VIEW_FIELDS: 'activityBuilder/activityComputedFields/GRID_VIEW_FIELDS',
	COMPUTED_FIELDS: 'activityBuilder/activityComputedFields/COMPUTED_FIELDS',
	LOADING: 'activityBuilder/activityComputedFields/LOADING',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
export default {
	state: {
		computedFields: [],
		gridViewFields: [],
		selectedComputedField: null,
		loading: false,
	},
	mutations: {
		[Mutations.SET_COMPUTED_FIELDS](state, items) {
			state.computedFields = items;
		},
		[Mutations.SET_GRID_VIEW_FIELDS](state, items) {
			state.gridViewFields = items;
		},
		[Mutations.SET_SELECTED_COPMUTED_FIELD](state, item) {
			state.selectedComputedField = item;
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_COMPUTED_FIELDS, []);
				commit(Mutations.SET_GRID_VIEW_FIELDS, []);
				commit(Mutations.SET_SELECTED_COPMUTED_FIELD, null);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getComputedFieldsByActivityId(id)
					.then((resp) => {
						commit(Mutations.SET_COMPUTED_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_COMPUTED_FIELD_BY_ID]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getComputedFieldById(id)
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_COPMUTED_FIELD,
							resp.data
						);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_GRID_VIEW_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getGridViewFieldsByActivityId(id)
					.then((resp) => {
						commit(Mutations.SET_GRID_VIEW_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_COMPUTED_FIELD]({ dispatch, state }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteComputedField(id)
					.then(() => {
						let computedField = state.computedFields;
						let field = state.computedFields.find(
							(x) => x.Id == id
						);
						if (field) {
							let index = computedField.indexOf(field);
							computedField.splice(index, 1);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.INSERT_COMPUTED_FIELD]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertComputedField(item)
					.then((resp) => {
						state.computedFields.push(resp.data);
						commit(
							Mutations.SET_SELECTED_COPMUTED_FIELD,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_COMPUTED_FIELD]({ dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateComputedField(item)
					.then(() => {
						let computedField = state.computedFields;
						let field = state.computedFields.find(
							(x) => x.Id == item.Id
						);
						if (field) {
							let index = computedField.indexOf(field);
							computedField.splice(index, 1, item);
						}
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.COMPUTED_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.computedFields));
		},
		[Getters.GRID_VIEW_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.gridViewFields));
		},
		[Getters.SELECTED_COPMUTED_FIELD]: (state) => {
			return state.selectedComputedField;
		},
		[Getters.LOADING]: (state) => {
			return state.loading;
		},
	},
};
